import { FaCircleInfo } from "react-icons/fa6";
import "../layout/style.scss";
import { Radio } from "antd";
import { useSignUp } from "../../../../../../utils/CustomFunctions";
import { useSelector } from "react-redux";
import { FaSyncAlt } from "react-icons/fa";

const VenuePage = () => {
  const { venue_page_settings } = useSelector((state) => state.admin);

  const initialState = {
    enable_comments: venue_page_settings?.enable_comments || "facebook",
    app_id: venue_page_settings?.app_id || "",
    subdomain: venue_page_settings?.subdomain || "",
  };

  // validate fields
  const validateFields = (values) => {
    let newErrors = {};
    return newErrors;
  };

  const { values, errors, isPending, handleChange, handleSubmit } = useSignUp(
    initialState,
    validateFields,
    `admin/add_venue_page_settings`,
    "venue_page_settings"
  );

  return (
    <>
      <div className="card box">
        <div className="card-body">
          <div className="OrganizerProfileSection">
            <form onSubmit={handleSubmit} className="signform mt-3 ">
              <div className="ProfileSettingOptionsContainer">
                <div className="ProfileSettingOptionsBox">
                  <span className="ProfileSettingOptionTitle">
                    Enable comments
                    <span style={{ color: "red" }}>*</span>
                  </span>

                  <div className="ProfileSettingRadioBtns">
                    <Radio
                      className="ProfileSettingRadioBtn"
                      name="enable_comments"
                      checked={values.enable_comments === "no"}
                      onChange={handleChange}
                      value="no"
                    >
                      No
                    </Radio>
                    <Radio
                      className="ProfileSettingRadioBtn "
                      name="enable_comments"
                      checked={values.enable_comments === "facebook"}
                      onChange={handleChange}
                      value="facebook"
                    >
                      Facebook comments
                    </Radio>
                    <Radio
                      className="ProfileSettingRadioBtn"
                      name="enable_comments"
                      checked={values.enable_comments === "disqus"}
                      onChange={handleChange}
                      value="disqus"
                    >
                      Disqus comments
                    </Radio>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="Facebook_app_id" className="form-label fw-600">
                  Facebook app id
                </label>
                <div className="ProfleSettingOptionDescBox">
                  <FaCircleInfo className="ProfleSettingOptionDescIcon me-1" />
                  <span className="ProfleSettingOptionDesc">
                    Go to the documentation to get help about getting an app ID
                  </span>
                </div>
                <input
                  type="text"
                  name="app_id"
                  id="Facebook_app_id"
                  className="form-control"
                  value={values.app_id}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="subdomain" className="form-label fw-600">
                  Disqus subdomain
                </label>
                <div className="ProfleSettingOptionDescBox">
                  <FaCircleInfo className="ProfleSettingOptionDescIcon me-1" />
                  <span className="ProfleSettingOptionDesc">
                    Go to the documentation to get help about setting up Disqus
                  </span>
                </div>
                <input
                  type="text"
                  name="subdomain"
                  id="subdomain"
                  className="form-control"
                  value={values.subdomain}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-4 mb-3">
                <button
                  className="btn btn-dark rounded-5"
                  disabled={isPending ? "disabled" : ""}
                  type="submit"
                >
                  {isPending ? <FaSyncAlt className="spinIcon" /> : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default VenuePage;
